import { Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIcon } from '@ng-icons/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { Breadcrumb, BreadcrumbNav } from 'excellence-ui';

@Component({
  selector: 'app-supplier-contracts-details-breadcrumb-nav',
  imports: [BreadcrumbNav, Breadcrumb, RouterLink, NgIcon, TranslocoPipe],
  templateUrl: './supplier-contracts-details-breadcrumb-nav.html',
})
export class SupplierContractsDetailsBreadcrumbNav {
  organizationId = input.required<string>();
  supplierContractId = input.required<string>();
}
